module.exports = __webpack_public_path__ + "img/61873389.3c58d476.png";